import { getPosts } from "../../redux/features/post/postSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import "./NewsTicker.scss";

const NewsTicker = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  const { posts } = useSelector((state) => state.post);
  const latestUpdate = posts.find((post) => post?.category === "World News");

  let date = new Date(latestUpdate?.createdAt);

  const d = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return (
    <div className="news--ticker">
      <div className="contain">
        <div className="title">
          <h2>News Update</h2>
          <span>(Update {d})</span>
        </div>
      </div>
    </div>
  );
};
export default NewsTicker;
